export default "assets/images/icons/download-4a475986.svg";